import { User } from "@/v2/types";
import ArFilterCombobox from "../../ui/combo-box/FilterComboBox";
import FindAllUser from "@/v2/api/users/FindAll";

interface ArUserFilterComboBoxProps {
    value?: string; // The selected user ID
    onChange?: (userId: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    label?: string;
}

export default function ArUserFilterComboBox({
    value,
    onChange,
    placeholder = "Select coordinator...",
    disabled = false,
    className,
    label = "Coordinator",
}: ArUserFilterComboBoxProps) {
    const handleSelect = (item: User | null) => {
        if (onChange) {
            onChange(item ? item.id : "");
        }
    };

    const renderUserItem = (user: User) => (
        <div className="flex flex-col">
            <span>{user.full_name}</span>
            {user.email && (
                <span className="text-xs text-muted-foreground">
                    {user.email}
                </span>
            )}
        </div>
    );

    return (
        <ArFilterCombobox<User>
            label={label}
            labelAlign="items-start"
            queryKey={["users"]}
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllUser({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            additionalFilters={{ is_ar_employee: { eq: [true] } }}
            getDisplayValue={(user: User) => user.full_name}
            renderItem={renderUserItem}
            placeholder={placeholder}
            searchPlaceholder="Search coordinator..."
            className={className}
            disabled={disabled}
            onItemSelect={handleSelect}
            defaultValueId={value}
            pageSize={20}
            debounceMs={300}
        />
    );
}
